export default __webpack_public_path__ + "static/media/radio.4d022109.svg";